<template>
  <div class="tuiguang">
    <el-dialog :visible.sync="dialogVisible" width="860" :modal-append-to-body="false">
      <div class="content">
        <div class="images">
          <el-image
            v-for="(item, index) in previewList"
            :key="index"
            :src="item"
            class="img"
            :preview-src-list="previewList"
            :initial-index="index"
          >
          </el-image>
        </div>
        <div class="btns">
          <div class="btn">
            <div class="save" @click.stop="saveFn(0)"></div>
          </div>
          <div class="btn">
            <div class="save" @click.stop="saveFn(1)"></div>
          </div>
          <div class="btn">
            <div class="save" @click.stop="saveFn(2)"></div>
          </div>
          <div class="btn">
            <div class="save" @click.stop="saveFn(3)"></div>
          </div>
        </div>
        <transition name="el-zoom-in-bottom">
          <div class="progress" v-show="progressPercent > 0">
            <el-progress :show-text="false" :percentage="progressPercent"></el-progress>
          </div>
        </transition>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import haibao1 from "@/assets/image/haibao/1.webp";
import haibao2 from "@/assets/image/haibao/2.webp";
import haibao3 from "@/assets/image/haibao/3.webp";
import haibao4 from "@/assets/image/haibao/4.webp";
export default {
  data() {
    return {
      previewList: [haibao1, haibao3, haibao2, haibao4],
      dialogVisible: false,
      code: "",
      canvasData: null,
      // haibaoUrl:'https://meimengapp.oss-cn-beijing.aliyuncs.com/znsign/poster/template.png'
      //   devicePixelRatio: 1,
      progressPercent: 0,
      haibaoList: [
        {
          url: haibao1,
          width: 1380,
          height: 9789,
          textX: 550, // 原始图上相对坐标
          textY: 9130,
          color: "#0071FF",
        },

        {
          url: haibao3,
          width: 1380,
          height: 6387,
          textX: 550,
          textY: 5720,
          color: "#3119FF",
        },
        {
          url: haibao2,
          width: 1380,
          height: 5349,
          textX: 300,
          textY: 4660,
          color: "#262626",
        },
        {
          url: haibao4,
          width: 1380,
          height: 5955,
          textX: 550,
          textY: 5290,
          color: "#0045A4",
        },
      ],
      currentHaibaoIndex: 0,
    };
  },
  computed: {
    devicePixelRatio() {
      return window.devicePixelRatio || 1;
    },
  },
  methods: {
    async show(code) {
      this.dialogVisible = true;
      this.code = code;
    },
    async renderCanvas() {
      // 清理之前的 canvas
      if (this.canvasData) {
        this.canvasData = null;
      }

      const haibao = this.haibaoList[this.currentHaibaoIndex];
      const ratio = this.devicePixelRatio;

      const canvas = document.createElement("canvas");
      canvas.width = haibao.width * ratio;
      canvas.height = haibao.height * ratio;

      const ctx = canvas.getContext("2d");
      const image = new Image();

      try {
        image.crossOrigin = "Anonymous";
        image.src = haibao.url;
        this.progressPercent = 10;
        await new Promise((resolve, reject) => {
          image.onload = resolve;
          this.progressPercent = 30;
          image.onerror = () => reject(new Error("图片加载失败"));
        });

        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
        this.progressPercent = 60;
        // 文字绘制
        ctx.font = `${100 * ratio}px Arial`;
        ctx.fillStyle = haibao.color;
        // const textWidth = ctx.measureText(this.code).width;
        ctx.fillText(this.code, haibao.textX * ratio, haibao.textY * ratio);
        this.progressPercent = 90;
        this.canvasData = canvas;
      } catch (error) {
        console.error("生成海报失败:", error);
        this.$message.error("生成海报失败，请重试");
        throw error;
      }
    },
    async saveFn(index) {
      this.currentHaibaoIndex = index;
      this.progressPercent = 0;
      await this.renderCanvas();
      this.progressPercent = 100;
      const dataURL = this.canvasData.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.href = dataURL;
      downloadLink.download = `share_${index + 1}.png`;
      downloadLink.click();
      setTimeout(() => {
        this.progressPercent = 0;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.tuiguang {
  @include dialog860Style;
}
.content {
  width: 860px;
  height: 450px;
  background-image: url(~@/assets/image/haibao/bg.webp);
  background-size: 100%;
  position: relative;
  .images {
    display: flex;
    padding: 0 28px;
    justify-content: space-between;
    padding-top: 120px;
    .img {
      width: 188px;
      height: 280px;
      cursor: pointer;
      opacity: 0;
      z-index: 3;
    }
  }
  .btns {
    display: flex;
    padding: 0 28px;
    justify-content: space-between;
    padding-top: 0px;
    .btn {
      width: 188px;
      height: 90px;
      cursor: pointer;
      position: relative;
      margin-top: -90px;
      // background: #6f6;
      .save {
        width: 26px;
        height: 16px;
        position: absolute;
        left: 10px;
        bottom: 10px;
        z-index: 4;
      }
    }
  }
  .progress {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
}
</style>
